<template>
  <!--PPAP 文件清单-->
  <h-list-page>
    <div style="position: relative;margin-top: 10px;">
      <h-table-card :title="h_i18n('b3b14d334f3fc995b1abe3b8d44e3a5b')" :h-data="tableDataList">
        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="loading.table" :span-method="arraySpanMethod"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small">
          <el-table-column :label="h_i18n('d316330b742ea7b420665a3df7ec374d')" prop="selfStage" width="80" :formatter="phaseFormatter"></el-table-column>
          <el-table-column :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" prop="fileOrder" width="40"></el-table-column>
          <el-table-column :label="h_i18n('5a0397a0d8242ae4786400e0940b7046')" prop="fileName" min-width="200">
            <template #default="{row}">
              <span class="h-global-font--blue" @click="download({name:row.fileUpName,url:row.fileUuid})">{{ row.fileName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="h_i18n('18eba50a63e54f245e803da4fb65fd84')" width="40">
            <el-table-column label="SQE" prop="isNeedSqe" width="100" :formatter="otherStatusFormatter"></el-table-column>
            <el-table-column label="R&D" prop="isNeedRd" width="100" :formatter="otherStatusFormatter"></el-table-column>
            <el-table-column label="JIT" prop="isNeedJit" width="100" :formatter="otherStatusFormatter"></el-table-column>
            <el-table-column label="IQC" prop="isNeedIqc" width="100" :formatter="otherStatusFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="PPAP" width="40">
            <el-table-column label="I" width="40">
              <el-table-column :label="h_i18n('ead1b501527ef31f0e6d779d10d27f00')" prop="isNeedOne" width="100" :formatter="ppapStatusFormatter"></el-table-column>
            </el-table-column>
            <el-table-column label="II" width="40">
              <el-table-column :label="h_i18n('5fc9de04f6d3fe83c71a09176fac2e1d')" prop="isNeedTwo" width="100" :formatter="ppapStatusFormatter"></el-table-column>
            </el-table-column>
            <el-table-column label="III" width="40">
              <el-table-column :label="h_i18n('2ab123036ccd25685fc06fa4dac80448')" prop="isNeedThree" width="100" :formatter="ppapStatusFormatter"></el-table-column>
            </el-table-column>
            <el-table-column label="IV" width="40">
              <el-table-column :label="h_i18n('fd05ec99e6c85414f2bc1c2aedd9497c')" prop="isNeedFour" width="100" :formatter="ppapStatusFormatter"></el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
      </h-table-card>
    </div>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


import {DataFormatter, Loading, LoadingButton, Request} from "../../../Decorator/vue2-decorator.js";

export default {
  name: "PPAPApplicabilityEvaluationList",
  data() {
    return {
      loading: {
        table: false,
        add: false,
        update: false,
        delete: false
      },
      tableDataList: [],
      historyList: [],
      phaseList: [],
      name: "",
      phaseObject: {
        1: h_i18n('3eb25280452a44644cc8137c9b3c247d'),
        2: h_i18n('c3b62511ecfaa5caa454304f2cd60ad8'),
        3: h_i18n('385fc63a49de9576e68c1838efce62ce'),
        4: h_i18n('b7fcfaf05a772a4baf2e9509d9f434be')
      },
      otherStatus: {
        "Y": "R",
        "N": "⊙"
      },
      ppapStatus: {
        "Y": "√",
        "N": "/"
      },
      submitData: {},
      type: "submit",
      submitDrawer: false,
      file: {},
      multipleSelection: [],
      flow: false
    }
  },
  methods: {
    h_i18n,
    error(value) {
      this.warning(value.message)
    },
    changeMethod() {
      this.postThisPageHeight()
    },

    // @Loading("文件下载中...")
        // @Request("")
    download(file) {
      // window.open( "/tosqmfordown/downLoadFile?appName=mkhl&fileUUID=" + file.url )
      // return
      let baseUrl = ""
      if (!file.url.includes(".")) {
        // baseUrl = "/tosqmfordown/downLoadFile?appName=mkhl&fileUUID=" + file.url
        baseUrl = "/base/fileDownload/downloadFile?filePath=" + file.url
        // baseUrl = `/vmiService/fileDownload/downloadFile?filePath=${file.url}`
      } else {
        baseUrl = "/base/fileDownload/downloadFile?filePath=" + file.url
      }
      this.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
      this.httpFile({
        method: "get",
        url: baseUrl,
        headers: {'content-type': 'application/json'},
      }, file.name)
      // return request({
      //   method: "GET",
      //   url: baseUrl,
      // }).then(res => {
      //   if (res.status === 200) {
      //     let blob = new Blob([res.data], {
      //       type: "application/vnd.ms-excel",
      //     }); // 文件流
      //     let blobUrl = URL.createObjectURL(blob);
      //     const link = document.createElement("a"); //模拟a链接，不支持低版本ie
      //     link.download = file.name;
      //     link.style.display = "none";
      //     link.href = blobUrl;
      //     document.body.appendChild(link);
      //     link.click();
      //     URL.revokeObjectURL(link.href);
      //     document.body.removeChild(link);
      //   }
      // })
    },

    @LoadingButton("table")
        @Request("vmiService")
    searchTableList() {
      this.tableDataList = []
      this.phaseList = []
      request({
        method: "GET",
        url: "/patternPlan/searchPpapFileConfig",
      }).then(res => {
        if (res.data.code === "200") {
          let l1 = res.data.data.filter(v => v["selfStage"] === 1)
          let l2 = res.data.data.filter(v => v["selfStage"] === 2)
          let l3 = res.data.data.filter(v => v["selfStage"] === 3)
          let l4 = res.data.data.filter(v => v["selfStage"] === 4)
          this.tableDataList.push(...l1)
          this.tableDataList.push(...l2)
          this.tableDataList.push(...l3)
          this.tableDataList.push(...l4)
          let list = this.tableDataList.map(v => v["selfStage"])
          for (let i = 1; i <= 4; i++) {
            this.phaseList.push(list.indexOf(i))
          }
        }
      }, () => this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3')))
    },

    @DataFormatter(3, "phaseObject")
    phaseFormatter(value) {return value},

    @DataFormatter(3, "otherStatus")
    otherStatusFormatter(value) {return value},

    @DataFormatter(3, "ppapStatus")
    ppapStatusFormatter(value) {return value},

    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        if (this.phaseList.includes(rowIndex)) {
          let len = this.tableDataList.length
          if (this.phaseList.indexOf(rowIndex) === 0) {
            return [this.phaseList[1] - this.phaseList[0], 1]
          } else if (this.phaseList.indexOf(rowIndex) === 1) {
            return [this.phaseList[2] - this.phaseList[1], 1]
          } else if (this.phaseList.indexOf(rowIndex) === 2) {
            return [this.phaseList[3] - this.phaseList[2], 1]
          } else if (this.phaseList.indexOf(rowIndex) === 3) {
            return [len - this.phaseList[2], 1]
          }
        } else {
          return [0, 0]
        }
      }
    },
    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },
    init() {
      this.name = this.$route.query.name
      this.searchTableList();
    },
  },
  mounted() {
    this.init()
  },
  activated() {}
};
</script>

<style lang="scss" scoped>
:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #ccc;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}

:deep(.el-input-number) {
  width: 100%;
  line-height: 30px;
}

.area {
  :deep(.el-radio-button__inner) {
    width: 40px;
  }
}


:deep(.text-top) {
  width: auto;

  .haier-search--text {
    width: 100%;
  }

  .haier-search--slot {
    width: 100%;
  }
}
</style>